// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import React, { ReactElement } from 'react';

import './CustomColorLabel.scss';

interface CustomColorLabelProps {
    value: string;
    color?: string;
    className?: string;
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
    disabled?: boolean;
}

export const CustomColorLabel = ({
    value,
    color,
    className,
    onClick,
    disabled = false,
}: CustomColorLabelProps): ReactElement => {
    return (
        <span
            className={classList('custom-color-option', className, {
                [`color-option-clickable`]: !!onClick && disabled === false,
            })}
            style={{ [`--custom-color` as string]: color }}
            {...(onClick && !disabled ? { onClick } : {})}
        >
            {value}
        </span>
    );
};
